import {
  ApiBlueprint,
  FrontendPlugin,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { OpsiclePocApiClient } from './api/OpsiclePocApiClient';
import { opsiclePocApiRef } from './api/apiRef';
import { rootRouteRef } from './routes';

const opsiclePocApi = ApiBlueprint.make({
  name: 'opsicle-poc',
  params: define =>
    define({
      api: opsiclePocApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new OpsiclePocApiClient({ discoveryApi, fetchApi }),
    }),
});

const opsiclePocPage = PageBlueprint.make({
  name: 'opsicle-poc',
  params: {
    path: '/opsicle-poc',
    routeRef: rootRouteRef,
    loader: () => import('./components/PocPage').then(m => <m.PocPage />),
  },
});

/**
 * Side by side with the production Opsicle plugin, never inside it.
 *
 * `plugins/opsicle` serves the real Operations tab. Keeping the POC in its own
 * plugin at its own route means a bug here cannot take that tab down, which is
 * the same separation the backend already holds between `opsicle-backend` and
 * `opsicle-poc-backend`.
 */
const opsiclePocPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'opsicle-poc',
  routes: { root: rootRouteRef },
  extensions: [opsiclePocApi, opsiclePocPage],
});
export default opsiclePocPlugin;
